/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Chip, Tooltip, TextField, Typography, InputAdornment } from "@material-ui/core";
import { Clear, Description } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import KPTable from "../../../components/KPTable";
import ProjectDeleteModal from "../ProjectDeleteModal";
import ProjectUpdateModal from "../ProjectUpdateModal";

import { statisticUnaccepted } from "../../../reducer/profile/action";
import { acceptProject, updateProject, requestRevisionProject } from "../../../reducer/project/action";
import { changePages } from "../../../reducer/home/action";
import ProjectHistoryModal from "../ProjectHistoryModal";
import { apiCall } from "../../../utils/api";
import { API_URLS } from "../../../constants/api";
import {
  WorkflowStatusChip,
  RevisionRequestLink,
  RevisionRequestDialog,
  STATUS_META,
  workflowMetaColumns,
  WorkflowFilterBar,
  ExportExcelButton,
  applyConditions,
} from "../../../components/WorkflowStatus";

const deriveStatus = (row) => {
  if (row?.revisionStatus === "requested") return "revisionRequested";
  if (row?.revisionStatus === "resubmitted") return "resubmitted";
  if (row?.accepted) return "approved";
  return "pending";
};

function ProjectTable(props) {
  const [editting, setEditting] = useState(null);
  const [updating, setUpdating] = useState(null);
  const [deleting, setDeleting] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [historyRow, setHistoryRow] = useState(null);
  const [revisionRow, setRevisionRow] = useState(null);
  const [revisionSubmitting, setRevisionSubmitting] = useState(false);
  const [advancedConditions, setAdvancedConditions] = useState([]);
  useEffect(() => {
    setAdvancedConditions([]);
  }, [props.type]);
  // Single round-trip cache: { [projectId]: count }. Read by the "Bài báo
  // liên kết" column to render a chip without one request per row.
  const [linkedCounts, setLinkedCounts] = useState({});

  useEffect(() => {
    let cancelled = false;
    const fetchCounts = async () => {
      const api = API_URLS.SCIENTIFIC_RESEARCH.getLinkedProjectCounts();
      const { response, error } = await apiCall({ ...api });
      if (cancelled) return;
      if (!error && response?.status === 200 && response.data?.success) {
        setLinkedCounts(response.data.data || {});
      }
    };
    fetchCounts();
    return () => {
      cancelled = true;
    };
  }, [updating]);

  const handleUpdate = (e) => setUpdating(e);
  const handleEditYear = (e) => setEditting(e);

  const handleDelete = (event, e) => {
    setDeleting(e.id);
    setAnchorEl(event.currentTarget);
  };

  const handleChange = (value) => setEditting({ ...editting, dashboardYear: value });

  const handleAccept = (e) => {
    props.acceptProject(e.id, !e.accepted).then((success) => {
      if (success) {
        props.statisticUnaccepted({ departmentId: 0, profileId: props.profile?.id });
        if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    props.updateProject(editting.id, editting);
    setEditting(null);
  };

  const handleClear = () => {
    props.updateProject(editting.id, { ...editting, dashboardYear: null });
    setEditting(null);
  };

  const list = [];
  if (props.type === "all") props.listProject.forEach((e) => list.push(e.researchProject));
  else props.listProjectById.forEach((e) => list.push(e.researchProject));

  // Compute once so both the filter bar (suggestions) and the export button
  // (output) see the same rows. KPTable still does its own column filtering on
  // top — that's a per-render concern handled inside the table.
  const enrichedRows = list.map((item) => ({ ...item, _status: deriveStatus(item) }));
  const filteredRows = applyConditions(enrichedRows, advancedConditions);
  const departmentName = (props.departments || []).find((d) => d.id === props.department)?.name;

  return (
    <>
      <div style={{ display: "flex", alignItems: "flex-start", gap: 8, marginBottom: 4 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <WorkflowFilterBar
            conditions={advancedConditions}
            onChange={setAdvancedConditions}
            rows={enrichedRows}
          />
        </div>
        <ExportExcelButton rows={filteredRows} workType="researchProject" />
      </div>
      <KPTable
        shadow="none"
        rowsPerPage={10}
        maxHeight="calc(100vh - 320px)"
        columns={[
          {
            title: <b>Tác vụ</b>,
            key: "action",
            width: "20%",
            render: (value, row) =>
              row?.id !== editting?.id ? (
                <>
                  <Typography
                    className="table-action-buton"
                    variant="caption"
                    color="primary"
                    onClick={() => handleUpdate(row)}
                  >
                    Chi tiết
                  </Typography>
                  <Typography
                    className="table-action-buton"
                    variant="caption"
                    color="primary"
                    onClick={() => setHistoryRow(row)}
                  >
                    Lịch sử
                  </Typography>
                  {row.locked ? (
                    <Typography className="table-action-buton" variant="caption" color="textPrimary">
                      {`Đã khóa ${
                        (row.locked === "kpi" && "KPI") ||
                        (row.locked === "reward" && "thưởng") ||
                        (row.locked === "timeResearch" && "giờ nghiên cứu")
                      }`}
                    </Typography>
                  ) : (
                    <>
                      {(props.type !== "all" || props.role === "sudo-admin") && !row.accepted && (
                        <Typography
                          className="table-action-buton"
                          variant="caption"
                          color="secondary"
                          onClick={(event) => handleDelete(event, row)}
                        >
                          Xoá
                        </Typography>
                      )}
                      {props.role === "sudo-admin" && props.filter !== "workingPaper" && row.purposeId !== 4 && (
                        <>
                          <Typography
                            className="table-action-buton"
                            variant="caption"
                            color="primary"
                            onClick={(event) => handleAccept(row)}
                          >
                            {row.accepted ? "Hủy duyệt" : "Duyệt"}
                          </Typography>
                          <RevisionRequestLink row={row} onClick={setRevisionRow} />
                        </>
                      )}
                    </>
                  )}
                </>
              ) : (
                <>
                  <Typography className="table-action-buton" variant="caption" color="primary" onClick={handleSubmit}>
                    Lưu
                  </Typography>
                  <Typography
                    className="table-action-buton"
                    variant="caption"
                    color="secondary"
                    onClick={() => setEditting(null)}
                  >
                    Huỷ
                  </Typography>
                </>
              ),
          },
          {
            title: <b>Tên đề tài</b>,
            key: "title",
            width: props.role === "sudo-admin" ? "20%" : "30%",
            sortable: true,
            searchable: true,
          },
          {
            title: <b>Xếp loại</b>,
            key: "type",
            width: "20%",
            filters: [
              {
                text: "Cơ bản",
                value: "basic",
              },
              {
                text: "Ứng dụng",
                value: "application",
              },
            ],
            onFilter: (value, row) => row.filter((e) => value === e.type),
            render: (value) => (value === "basic" ? "Cơ bản" : value === "application" ? "Ứng dụng" : ""),
          },
          {
            title: <b>Giá trị</b>,
            key: "value",
            width: "15%",
            render: (value) => `${value} VND`,
          },
          props.role === "sudo-admin" && props.type === "all"
            ? {
                title: <b>Năm hiển thị</b>,
                key: "dashboardYear",
                width: "12%",
                searchable: true,
                render: (value, row) =>
                  row?.id !== editting?.id ? (
                    <Tooltip title="Click để chỉnh sửa năm">
                      <div style={{ cursor: "pointer" }} onClick={() => handleEditYear(row)}>
                        {value > 0 ? value : "Chưa có năm hiển thị"}
                      </div>
                    </Tooltip>
                  ) : (
                    <form onSubmit={handleSubmit}>
                      <TextField
                        fullWidth
                        size="small"
                        type="tel"
                        variant="outlined"
                        value={editting?.dashboardYear || ""}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end" style={{ cursor: "pointer" }} onClick={handleClear}>
                              <Clear style={{ fontSize: 18 }} />
                            </InputAdornment>
                          ),
                        }}
                        onChange={(e) => handleChange(parseInt(e.target.value))}
                      />
                    </form>
                  ),
              }
            : {
                key: "dashboardYear",
                width: "0%",
                render: () => null,
              },
          {
            title: <b>Trạng thái</b>,
            key: "_status",
            width: "13%",
            render: (_, row) => <WorkflowStatusChip row={row} />,
            type: "include",
            filters: Object.entries(STATUS_META).map(([value, meta]) => ({ value, text: meta.label })),
            onFilter: (value, rows) => rows.filter((e) => value.includes(e._status)),
          },
          {
            title: <b>Bài báo liên kết</b>,
            key: "linkedScientificResearchCount",
            width: "12%",
            render: (_, row) => {
              const count = linkedCounts[String(row.id)] || 0;
              if (count === 0) {
                return (
                  <Typography variant="caption" style={{ color: "#9e9e9e" }}>
                    Chưa có
                  </Typography>
                );
              }
              return (
                <Tooltip title="Mở chi tiết đề tài để xem danh sách bài báo">
                  <Chip
                    size="small"
                    icon={<Description style={{ fontSize: 16 }} />}
                    label={`${count} bài`}
                    onClick={() => handleUpdate(row)}
                    style={{
                      backgroundColor: "#e3f2fd",
                      color: "#1565c0",
                      fontWeight: 600,
                      cursor: "pointer",
                    }}
                  />
                </Tooltip>
              );
            },
            sorter: (a, b) =>
              (linkedCounts[String(a.id)] || 0) - (linkedCounts[String(b.id)] || 0),
          },
          ...workflowMetaColumns({ width: "10%" }),
        ]}
        rows={filteredRows
          .slice()
          .sort((a) => (!a.accepted ? -1 : 1))
          .slice(10 * props.workPages[4], 10 * (props.workPages[4] + 1))}
        totalData={filteredRows?.length}
        loading={props.isFetching}
        page={props.workPages[4]}
        onPageChange={(newPage) => props.changePages(4, newPage - 1)}
      />

      <ProjectUpdateModal adminTab={props.adminTab} updating={updating} setUpdating={setUpdating} />
      <ProjectDeleteModal deleting={deleting} anchorEl={anchorEl} setAnchorEl={setAnchorEl} />
      <ProjectHistoryModal open={!!historyRow} row={historyRow} onClose={() => setHistoryRow(null)} />
      <RevisionRequestDialog
        row={revisionRow}
        submitting={revisionSubmitting}
        onClose={() => setRevisionRow(null)}
        onSubmit={async (reason) => {
          setRevisionSubmitting(true);
          const ok = await props.requestRevisionProject(revisionRow.id, reason);
          setRevisionSubmitting(false);
          if (ok) setRevisionRow(null);
        }}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  profile: select(state, "profileReducer", "detail"),
  workPages: select(state, "homeReducer", "workPages"),
  isFetching: select(state, "projectReducer", "isFetching"),
  listProject: select(state, "projectReducer", "listFiltered"),
  listProjectById: select(state, "projectReducer", "listById"),
  departments: select(state, "departmentReducer", "departments"),
});

const mapDispatchToProps = (dispatch) => ({
  acceptProject: (id, accept) => dispatch(acceptProject(id, accept)),
  updateProject: (id, payload) => dispatch(updateProject(id, payload)),
  requestRevisionProject: (id, reason) => dispatch(requestRevisionProject(id, reason)),
  statisticUnaccepted: (payload) => dispatch(statisticUnaccepted(payload)),
  changePages: (id, newPage) => dispatch(changePages(id, newPage)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(ProjectTable));

